var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 4,
    fill: "#8A99F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8641 18.8128C14.8852 18.9183 14.9743 19 15.0819 19H16.8673C17.4688 19 17.9214 18.471 17.7203 17.9042C17.3003 16.7199 16.2952 15 14.0001 15C13.8745 15 13.7528 15.0052 13.6348 15.0151C13.2591 15.0467 13.1629 15.5087 13.4151 15.7889C14.3198 16.7941 14.6999 17.9918 14.8641 18.8128ZM13.5277 17.8332C13.7714 18.4159 13.2918 19 12.6602 19H11.1329C10.5314 19 10.0788 18.4711 10.2799 17.9042C10.47 17.3683 10.7799 16.7226 11.275 16.1763C11.5534 15.869 12.022 15.8468 12.3327 16.1214C12.905 16.6274 13.2808 17.2429 13.5277 17.8332Z",
    fill: "#8A99F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C12.5715 15 13.5919 17.5512 13.8834 19.0089C13.9917 19.5504 13.5523 20 13 20H5C4.44772 20 4.00829 19.5504 4.11659 19.0089C4.4081 17.5512 5.42846 15 9 15Z",
    fill: "#8A99F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4821 12.5882C13.4183 11.6795 14 10.4077 14 9C14 8.29933 13.8559 7.63233 13.5957 7.02702C13.7279 7.0092 13.8629 7 14 7C15.6569 7 17 8.34315 17 10C17 11.6569 15.6569 13 14 13C13.4462 13 12.9274 12.8499 12.4821 12.5882ZM11.7119 11.9404C12.5039 11.2095 13 10.1627 13 9C13 8.40307 12.8692 7.83668 12.6348 7.32791C11.6643 7.82475 11 8.8348 11 10C11 10.7399 11.2679 11.4173 11.7119 11.9404Z",
    fill: "#8A99F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3V7",
    stroke: "#5664D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5L17 5",
    stroke: "#5664D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdminIcon);
export default __webpack_public_path__ + "static/media/userAdminIcon.77da52e55e16df0b8a1c9214390a76a5.svg";
export { ForwardRef as ReactComponent };